module.exports = __webpack_public_path__ + "img/9.f5c02daa.webp";